import { ReactComponent as ReactLogo } from "../../assets/background.svg";


const VerifyPage = () => {

    return (
        <div style={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <ReactLogo />

        </div>
    )
}

export default VerifyPage;
